import React from 'react';
import { Download, FileText, Loader2 } from 'lucide-react';
import { formatFileSize } from './sharedAccessFormatters';

/** Purpose: Renders shared records list with download actions. Inputs: props. Output: React render output (JSX). */
export default function SharedDownloadView({
  sharedRecords,
  downloadingFileId,
  onDownload,
  formatRecordType,
  formatDate
}) {
  return (
    <section className="space-y-4">
      <h2 className="text-lg font-semibold text-slate-900">Shared Records</h2>
      {sharedRecords.length === 0 ? (
        <div className="bg-white rounded-xl shadow-sm border border-slate-200 p-6 text-sm text-slate-600">
          No records were shared with this link.
        </div>
      ) : (
        sharedRecords.map((record) => (
          <div key={record.id} className="bg-white rounded-xl shadow-sm border border-slate-200 overflow-hidden">
            <div className="p-5">
              <div className="flex items-start gap-4">
                <div className="bg-gradient-to-br from-blue-500 to-indigo-500 p-3 rounded-lg">
                  <FileText className="w-6 h-6 text-white" />
                </div>
                <div className="flex-1">
                  <div className="flex items-center gap-3 mb-2">
                    <h3 className="text-lg font-semibold text-slate-900">{record.title}</h3>
                    <span className="px-2.5 py-1 bg-blue-100 text-blue-700 text-xs font-medium rounded-full">
                      {formatRecordType(record.type)}
                    </span>
                  </div>
                  <div className="grid grid-cols-1 md:grid-cols-3 gap-4 text-sm text-slate-600 mb-3">
                    <div>{record.provider || '-'}</div>
                    <div>{record.facility || '-'}</div>
                    <div>{formatDate(record.date)}</div>
                  </div>
                  {record.description && (
                    <p className="text-sm text-slate-600 mb-3">{record.description}</p>
                  )}
                  {Array.isArray(record.files) && record.files.length > 0 && (
                    <div className="mt-4 pt-4 border-t border-slate-100 space-y-2">
                      <p className="text-sm font-medium text-slate-700">Attached Files</p>
                      {record.files.map((file) => (
                        <div key={file.id} className="flex items-center justify-between bg-slate-50 rounded-lg px-3 py-2">
                          <div className="text-sm text-slate-700">
                            {file.fileName} <span className="text-slate-500">({formatFileSize(file.fileSize)})</span>
                          </div>
                          <button
                            onClick={() => onDownload(file.id, file.fileName)}
                            disabled={downloadingFileId === file.id}
                            className="flex items-center gap-1 px-3 py-1 bg-blue-600 text-white text-sm rounded-lg hover:bg-blue-700 disabled:opacity-50"
                          >
                            {downloadingFileId === file.id ? (
                              <Loader2 className="w-4 h-4 animate-spin" />
                            ) : (
                              <Download className="w-4 h-4" />
                            )}
                            Download
                          </button>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        ))
      )}
    </section>
  );
}

